import { useMemo } from 'react';

interface UseLineIconRenderProps {
  isReadOnly: boolean;
  widthPx: number;
  heightPx: number;
  strokeWidth: number;
}

// Multiplier to determine extra padding required around the icon
const STROKE_WIDTH_MULTIPLIER = 3.5;

/**
 * Returns the svg width, height and offset required for rendering the line icon in export view
 * Adds additional padding to account for arrow head / stroke width overflow
 *
 * @param param0
 * @returns
 */
export const useLineIconRender = ({ isReadOnly, widthPx, heightPx, strokeWidth }: UseLineIconRenderProps) => {
  const result = useMemo(
    () => ({
      svgWidth: isReadOnly ? widthPx + strokeWidth * STROKE_WIDTH_MULTIPLIER : widthPx,
      svgHeight: isReadOnly ? heightPx + strokeWidth * STROKE_WIDTH_MULTIPLIER : heightPx,
      offset: isReadOnly ? (strokeWidth * STROKE_WIDTH_MULTIPLIER) / 2 : undefined,
    }),
    [isReadOnly, widthPx, heightPx, strokeWidth],
  );
  return result;
};
